import { useEffect } from 'react';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/scroll-to-top';

// ----------------------------------------------------------------------

export default function App() {
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();

    const handleKeyDown = (e) => {
      // F12
      if (e.code === 'F12' || e.key === 'F12') {
        e.preventDefault();
        return;
      }

      const isTargetKey = ['KeyI', 'KeyJ', 'KeyC', 'KeyU'].includes(e.code);

      // Windows / Linux: Ctrl + Shift + I/J/C або Ctrl + U
      const isWinDevTools =
        e.ctrlKey && ((e.shiftKey && ['KeyI', 'KeyJ', 'KeyC'].includes(e.code)) || e.code === 'KeyU');

      // macOS: Cmd + Option + I/J/C/U або Cmd + Shift + C
      const isMacDevTools =
        e.metaKey && ((e.altKey && isTargetKey) || (e.shiftKey && e.code === 'KeyC'));

      if (isWinDevTools || isMacDevTools) {
        e.preventDefault();
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <ThemeProvider>
      <ScrollToTop />
      <Router />
    </ThemeProvider>
  );
}